import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  fromDate: null,    
  toDate: null,       
  filterModel: null,  
  sortModel: null,    
};

const dweListSlice = createSlice({
  name: 'dweList',
  initialState,
  reducers: {
    setDates(state, action) {
      const { fromDate, toDate } = action.payload || {};
      state.fromDate = fromDate ?? null;
      state.toDate = toDate ?? null;
    },
    setFilterModel(state, action) {
      state.filterModel = action.payload || null;
    },
    setSortModel(state, action) {
      state.sortModel = action.payload || null;
    },
    clearDweListState() {
      return initialState;
    },
  },
});

export const { setDates, setFilterModel, setSortModel, clearDweListState } =
  dweListSlice.actions;

export default dweListSlice.reducer;